export const BEHAVIOUR_LIST_PATH = '/dashboard/admin/behaviour-tracking';

const FILTER_KEYS = ['employee', 'from', 'to'];

export function readBehaviourListStateFromSearchParams(searchParams, defaultDates = {}) {
  return {
    employee: String(searchParams.get('employee') || ''),
    dateFilter: {
      from: String(searchParams.get('from') || defaultDates.from || ''),
      to: String(searchParams.get('to') || defaultDates.to || ''),
    },
  };
}

export function hasBehaviourListParams(searchParams) {
  if (!searchParams) return false;
  return FILTER_KEYS.some((key) => String(searchParams.get(key) || '').trim() !== '');
}

export function behaviourListStateToSearchParams({ employee, dateFilter } = {}) {
  const params = new URLSearchParams();
  const emp = String(employee || '').trim();
  if (emp) params.set('employee', emp);
  const from = String(dateFilter?.from || '').trim();
  const to = String(dateFilter?.to || '').trim();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  return params;
}

export function behaviourListPath(state) {
  const qs = behaviourListStateToSearchParams(state).toString();
  return qs ? `${BEHAVIOUR_LIST_PATH}?${qs}` : BEHAVIOUR_LIST_PATH;
}

export function getInitialBehaviourListState(defaultDates = {}) {
  const params = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  if (hasBehaviourListParams(params)) {
    return readBehaviourListStateFromSearchParams(params, defaultDates);
  }
  return {
    employee: '',
    dateFilter: {
      from: defaultDates.from || '',
      to: defaultDates.to || '',
    },
  };
}

export function behaviourListBackPath(location) {
  const from = location?.state?.from;
  if (typeof from === 'string') {
    const pathOnly = from.split('?')[0];
    if (pathOnly === BEHAVIOUR_LIST_PATH) {
      const qs = from.includes('?') ? from.slice(from.indexOf('?') + 1) : '';
      return behaviourListPath(
        readBehaviourListStateFromSearchParams(new URLSearchParams(qs))
      );
    }
  }
  return BEHAVIOUR_LIST_PATH;
}
